import createReactComponent from '../createReactComponent';
export default createReactComponent('menorah', 'IconMenorah', [
  ['path', { d: 'M12 4v16', key: 'svg-0' }],
  ['path', { d: 'M8 4v2a4 4 0 1 0 8 0v-2', key: 'svg-1' }],
  ['path', { d: 'M4 4v2a8 8 0 1 0 16 0v-2', key: 'svg-2' }],
  ['path', { d: 'M10 20h4', key: 'svg-3' }],
]);
